/**
 * QuizResultCTA - Bundle builder CTA for quiz results.
 *
 * Why this matters: The bundle offer still supports conversion after the
 * overhaul, but it should no longer depend on the old personality-reading API.
 */

import React from 'react';
import { TreeScore } from '../../utils/citrusQuizLogic';

interface QuizResultCTAProps {
  recommendations: TreeScore[];
}

const QuizResultCTA: React.FC<QuizResultCTAProps> = ({
  recommendations
}) => {
    const ctaTitle = `Build Your Citrus Bundle!`;

  // Calculate total for bundle pricing (only top 6 for bundle CTA)
  const bundleTrees = recommendations.slice(0, Math.min(recommendations.length, 6));
  const bundleTotal = bundleTrees.reduce((sum, r) => sum + r.tree.price, 0);
  const bundleDiscount = bundleTotal * 0.47; // 47% off bundle
  const bundlePrice = bundleTotal - bundleDiscount;
  const handleShopAll = () => {
    window.open('https://uscitrusnursery.com/pages/bundle-builder', '_blank', 'noopener,noreferrer');
  };
  return (
    <div className="results-footer-column results-bundle-cta">
      <div className="bundle-savings">
        <span className="bundle-discount"><i>Save 47%!</i></span>
        <div className="bundle-pricing">
          <h3 className="bundle-label-">{ctaTitle}</h3>
        </div>
      </div>
      <div className="bundle-savings-footer">
        <div className="bundle-savings-prices">
          <div className='bundle-savings-prices-column'>
            <span className="bundle-price">${bundlePrice.toFixed(2)}</span>
            <span className="bundle-original">${bundleTotal.toFixed(2)}</span>
          </div>
          <span className="bundle-discount hidden"><i>Save 47%!</i></span>
        </div>
        <span className='bundle-label independent-label hidden'>{ctaTitle}</span>
        <button className="bundle-btn" onClick={handleShopAll}>
          Get My Citrus Bundle!
          {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.75 7.75L14.75 7.75M14.75 7.75L7.75 0.75M14.75 7.75L7.75 14.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> */}
        </button>
      </div>
    </div>
  );
};

export default QuizResultCTA;
